import { Inject, Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { catchError, map, Observable, retry, share } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class ApiService extends BaseService {
    protected apiUrl: string = '';
    httpOptions = {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };

    constructor(@Inject(String) protected apiName: string, protected http: HttpClient, protected toastr: ToastrService) {
        super(toastr);
        if (!apiName.includes('http:') && !apiName.includes('https:')) {
            this.apiUrl = environment.appUrl;
        }
        this.apiUrl += apiName;
    }

    getAll<T>(endpoint: string = '', queryParams?: any): Observable<T> {
        return this.http.get(`${this.apiUrl}/${endpoint}`, { headers: this.httpOptions.headers, params: queryParams }).pipe(
            retry(2),
            catchError((error) => {
                return this.handleError(error);
            }),
            share()
        );
    }

    get<T>(id: string = '', queryParams?: any): Observable<T> {
        return this.http.get<T>(`${this.apiUrl}/${id}`, { headers: this.httpOptions.headers, params: queryParams }).pipe(
            catchError((error) => {
                return this.handleError(error);
            }),
            share()
        );
    }

    post<T>(data: any, endpoint: string = '', queryParams?: any): Observable<T> {
        return this.http.post(`${this.apiUrl}/${endpoint}`, data, { params: queryParams }).pipe(
            catchError((error) => {
                return this.handleError(error);
            }),
            map((response: any) => response as T),
            share()
        );
    }
}
